/*
 * "Quedan X" badges on the variant buttons (snippets/product-variant-options.liquid).
 * Uses the real stock rendered in [data-low-stock] (variants with 1-3 units left) and
 * refreshes on every option change, for the combination each button would select.
 */

(function() {
  const update = (picker) => {
    let stock = {};
    try {
      stock = JSON.parse(picker.querySelector('[data-low-stock]').textContent);
    } catch (error) {
      return;
    }

    const wrappers = Array.from(picker.querySelectorAll('[data-option-position]'));
    const selections = wrappers.map((wrapper) => {
      const checked = wrapper.querySelector('input[type="radio"]:checked');
      const hidden = wrapper.querySelector('input[data-popout-input]');
      return checked ? checked.value : hidden ? hidden.value : '';
    });
    const template = picker.dataset.lowStockLabel || '';

    wrappers.forEach((wrapper, position) => {
      wrapper.querySelectorAll('input[type="radio"]').forEach((input) => {
        const badge = input.parentElement.querySelector('[data-option-stock]');
        if (!badge) return;

        const options = [...selections];
        options[position] = input.value;
        const count = stock[options.join('||')];

        badge.hidden = !count;
        badge.textContent = count ? template.replace('||count||', count) : '';
      });
    });
  };

  const init = () => {
    document.querySelectorAll('.variant-picker').forEach((picker) => {
      if (picker.dataset.stockReady) return;
      picker.dataset.stockReady = 'true';
      picker.addEventListener('change', () => update(picker));
      update(picker);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
